export const defaultRange = 50;